import { render } from "./CraTaskManagement.vue?vue&type=template&id=73aa194a&scoped=true"
import script from "./CraTaskManagement.js?vue&type=script&lang=js"
export * from "./CraTaskManagement.js?vue&type=script&lang=js"

import "./CraTaskManagement.vue?vue&type=style&index=0&id=73aa194a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73aa194a"]])

export default __exports__